import { Button } from 'antd';
import styled from 'styled-components';

export const UserMenuStyled = styled.div`
	display: none;
	flex-direction: column;
	justify-content: flex-start;
	padding: 12px;
	width: 240px;
	border-radius: 8px;
	background-color: #fff;
	box-shadow:
		0px 3px 6px -4px rgba(0, 0, 0, 0.12),
		0px 6px 16px 0px rgba(0, 0, 0, 0.08),
		0px 9px 28px 8px rgba(0, 0, 0, 0.05);
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: flex;
	}
`;

export const ButtonStyled = styled(Button)`
	margin: 8px 0;
	padding: 0;
	width: fit-content;
	height: 22px;
	color: #2b2d42;
`;
